import { REPORT_STATES } from "../../../constants";

const applicable = (resp) => resp?.config.url.match(/api\/forms\/[0-9]+\/reports\?/g);

const modify = (resp) => {
	if(!resp.data?.Data) {
		return resp;
	}
	for(const data of resp.data.Data) {
		if(!data.Date && data.History[data.History.length - 1].State.Code === REPORT_STATES.pending.code) {
			data.History[data.History.length - 1].State = { 
				Code: REPORT_STATES.declared.code, Name: REPORT_STATES.declared.display
			};
		}
	}
	return resp;
};

export const declaredStatus = [applicable, modify];